var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4057 58.4786L25.6704 47.6619C22.0503 54.9775 20.0002 63.228 20 71.9996C20 80.6499 22.0722 88.9145 25.7479 96.295L44.4044 85.5238C42.5642 81.3803 41.5216 76.8102 41.5218 71.9996C41.522 67.1893 42.5653 62.6206 44.4057 58.4786Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.078 30.4853C101.412 22.0776 88.7812 16.9908 74.962 17C56.0555 17.0127 39.1804 26.6648 29.2655 41.4544L48.016 52.2804C54.1135 43.9629 63.9231 38.5216 75.0007 38.5218C83.076 38.522 90.4785 41.4086 96.2604 46.1919C97.6758 47.3626 99.7447 47.2554 101.043 45.9567L111.255 35.7449C112.728 34.2724 112.649 31.8517 111.078 30.4853Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.623 65.6364C129.409 63.8156 127.878 62.4373 126.046 62.4373L80.9784 62.435C78.9975 62.435 77.3913 64.0409 77.3913 66.022V80.3579C77.3913 82.3388 78.9973 83.9449 80.9784 83.9449H106.233C103.907 89.999 99.8664 95.2034 94.7226 98.9868L105.449 117.566C116.247 110.249 124.456 99.1868 128.072 86.1277C130.038 79.0274 130.391 72.1614 129.623 65.6364Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5202 102.59C84.3834 104.433 79.8166 105.478 75.0007 105.478C63.9106 105.479 54.1067 100.037 48.0135 91.7228L29.3429 102.502C39.1746 117.147 55.8606 127 75.0003 127C83.6525 127 91.8877 124.885 99.2538 121.181L88.5202 102.59Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f8428fbb.svg";
export { ForwardRef as ReactComponent };